import { GalleryCategory } from "@/types/models/galleryCategory";
import { Link } from "@inertiajs/react";
import Column from "../Grid/Column";
import Container from "../Grid/Container";
import Row from "../Grid/Row";

const CategoriesLoop = ({ categories }: { categories: GalleryCategory[] }) => {
    const getFormat = (filename: string) => {
        return filename.split('.').pop();
    };
    console.log(categories);
    return (
        <section className="mt-20 maxMd:mt-14">
            <Container>
                <Row>
                    {categories && categories.map((cat, i) => (
                        <Column xl={6} lg={6} md={12} key={i}>
                            <div className="relative">
                                {cat.photo &&
                                    <picture>
                                        <source
                                            srcSet={`${cat.photo.replace(/\.[^.]+$/, '')}.webp`}
                                            type="image/webp"
                                        />
                                        <source
                                            srcSet={`${cat.photo.replace(/\.[^.]+$/, '')}.${getFormat(cat.photo)}`}
                                            type={`image/${getFormat(cat.photo)}`}
                                        />
                                        <img className="w-full object-cover object-center" src={cat.photo} alt={cat.name} />
                                    </picture>
                                }
                            </div>
                            <h2 className="text-primary text-h3 leading-h3 font-extrabold uppercase text-left my-4">{cat.name}</h2>
                            <Link href={route('frontend.gallery.single', { galleryCategory: cat.slug })} className="button-outline border border-primary max-w-fit">
                                Przejdź do galerii
                            </Link>
                        </Column>
                    ))}
                </Row>
                <div className="mb-24 maxMd:mb-6"></div>
            </Container>
        </section>
    )
}

export default CategoriesLoop;